import auth0, { Auth0DecodedHash } from "auth0-js";
import { AUTH_CONFIG } from "./auth0-variables";
import { History } from "history";
import { getLegacyRegion } from "features/region/getLegacyRegion";

const STORAGE_KEY = "manage-auth";

class Auth {
    auth0 = new auth0.WebAuth({
        domain: AUTH_CONFIG.domain,
        clientID: AUTH_CONFIG.clientId,
        redirectUri: AUTH_CONFIG.callbackUrl,
        audience: `https://${AUTH_CONFIG.domain}/userinfo`, //TODO need to change this
        responseType: "token id_token",
        scope: "openid profile email",
    });

    private onLoginCBs: Function[] = [];

    login = (postLoginUrl: string) => {
        this.auth0.authorize({
            redirectUri: `${AUTH_CONFIG.callbackUrl}?after=${encodeURI(postLoginUrl)}`,
        });
    };

    onLogin = (cb: Function) => this.onLoginCBs.push(cb);

    handleAuthentication = (history: History, targetUrl: string) => {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);

                const params = new URLSearchParams(history.location.search);

                history.replace(params.get("after") || "/");
                this.onLoginCBs.forEach((cb) => cb());
            } else if (err) {
                console.log(err.errorDescription);
                this.logout();
            }
        });
    };

    setSession({ idToken, expiresIn, idTokenPayload }: Auth0DecodedHash) {
        if (idToken === undefined || expiresIn === undefined) {
            return;
        }

        const claim = idTokenPayload["https://meandu.com/access"];
        const model: AuthState = {
            idToken,
            defaultLocation: claim.location,
            id: idTokenPayload.sub,
            name: idTokenPayload.name,
            email: idTokenPayload.email,
            availableRegions: this.getRegionsFromPayload(claim),
            expiresAt: idTokenPayload.exp * 1000,
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(model));
    }

    getRegionsFromPayload = (claim: any) => {
        var availableRegions: string[] = [];

        if (claim.regions) {
            availableRegions = Object.keys(claim.regions);
        }

        availableRegions = availableRegions.filter((r) => !!r && r !== "*");
        if (!availableRegions.length) {
            availableRegions = [getLegacyRegion()];
        }

        return availableRegions;
    };

    getAvailableRegions = () => {
        const authState = this.getState();

        if (authState === null) {
            return null;
        }

        return authState.availableRegions;
    };

    logout = () => {
        // TODO
        // Clear access token and ID token from local storage
        localStorage.removeItem(STORAGE_KEY);

        this.auth0.logout({
            clientID: AUTH_CONFIG.clientId,
            returnTo: window.location.origin,
        });
    };

    isAuthenticated = () => {
        const authState = this.getState();

        if (authState === null) {
            return false;
        }
        const { expiresAt } = authState;
        return Date.now() < expiresAt;
    };

    getState() {
        const authValue = localStorage.getItem("manage-auth");
        if (authValue === null) {
            return null;
        }
        try {
            return JSON.parse(authValue) as AuthState;
        } catch (e) {
            return null;
        }
    }

    getAccessToken() {
        const authState = this.getState();

        if (authState === null) {
            return null;
        }

        return authState.idToken;
    }

    getDefaultLocation() {
        const authState = this.getState();

        if (authState === null) {
            return null;
        }

        return authState.defaultLocation;
    }
}

interface AuthState {
    idToken: string;
    expiresAt: number;
    defaultLocation: string | undefined;
    id: string;
    name: string;
    email: string;
    availableRegions: string[];
}

export const auth = new Auth();
